import React from 'react';
import { identityState, combineStates, siteSettingsState } from '../store';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import classNames from 'classnames';
import { translate } from '../services';

const FormattedPriceComponent = ( { price, priceClass, user, siteSettings,currency = null, isEstimated = false, fromheader = false, priceSize = 'small', showBothPricesInConfig = false ,fromFooter=false,excludeLooseAccPrice=false, fromCart=false} ) => {
  let activeCurrency = currency || siteSettings?.currency  || user?.currency;

  if( siteSettings.isSpecificCurrencyRequired ){
    activeCurrency = siteSettings.specificCurrency.hasOwnProperty(user.country)? siteSettings.specificCurrency[user.country] : siteSettings.specificCurrency['default'];
  }
  
  if( !price && siteSettings.hideNoPriceMessage ) { 
    if(fromCart && priceSize=='big'){
     return null;
    }
    else{
      let formattedPrice = new Intl.NumberFormat( user.culture, { style: 'currency', currency: activeCurrency } ).format( 0 )
    return <h2 className={ classNames( 'price ' + priceClass, { isEstimated } ) } >{formattedPrice} </h2>
  }}
  if( !price ) { 
    if(price===0 && fromCart){
       return <h6 className={ classNames( 'price ' + priceClass, { isEstimated } ) } title={ isEstimated ? translate( 'Price is estimated' ) : '' } >
           00.00
       </h6>;
     }
    return <span className={ 'priceOnRequest ' } title={ translate( "Price on request" ) } > {translate( "Price on request" ) }</span>
  }
  if(siteSettings.properties.priceFactor && user.authenticationType!='Cbol'){
    price = price*siteSettings.properties.priceFactor;
  }

  let formattedPrice = new Intl.NumberFormat( user.culture, { style: 'currency', currency: activeCurrency } ).format( price );
  if( priceSize === 'big' ){
  if(fromCart && !excludeLooseAccPrice){
      return <><span style={{paddingTop: "2px", width:"6em", fontSize:"1.2em"}}>{translate('Total')}</span><h2 className={ classNames( 'price ' + priceClass, { isEstimated } ) } title={ isEstimated ? translate( 'Price is estimated' ) : translate('') } >{  formattedPrice }</h2></>
    }
    else if(fromFooter && !excludeLooseAccPrice){
      return <><span style={{paddingTop: "2px", width:"6em", fontSize:"1.2em"}}>{translate('pricing including tax')}</span><h2 className={ classNames( 'price ' + priceClass, { isEstimated } ) } title={ isEstimated ? translate( 'Price is estimated' ) : translate('') } >{  formattedPrice }</h2></>
    }
    else if(excludeLooseAccPrice){
      return <><span style={{paddingTop: "3px", width:"3em", fontSize:"1.2em"}}>{translate('FGPrice')}</span><h2 className={ classNames( 'price ' + priceClass, { isEstimated } ) } title={ isEstimated ? translate( 'Price is estimated' ) : translate('') } >{  formattedPrice }</h2></>
    }
    return <h2 className={ classNames( 'price ' + priceClass, { isEstimated } ) } title={ isEstimated ? translate( 'Price is estimated' ) : '' } >{  formattedPrice }</h2>;
  }
  if( fromheader && showBothPricesInConfig ){
    return <h6 className={ 'header-price' } >{  formattedPrice }</h6>;
  }
  if( fromheader && !showBothPricesInConfig ){
    return <h2 className={ 'header-price' } >{  formattedPrice }</h2>;
  }
  return <h6 className={ classNames( 'price ' + priceClass, { isEstimated } ) } title={ isEstimated ? translate( 'Price is estimated' ) : '' } >{  formattedPrice }</h6>;
};

FormattedPriceComponent.propTypes = {
  price: PropTypes.number,
  user: PropTypes.shape( { 
    culture: PropTypes.string.isRequired,
    currency: PropTypes.string.isRequired 
  } ),
  siteSettings: PropTypes.shape( {
    currency: PropTypes.string.isRequired
  } ),
  className: PropTypes.bool
};

export const FormattedPrice = connect( combineStates( identityState, siteSettingsState  ) )( FormattedPriceComponent );
